// src/styles/layout.ts
// Shared layout tokens + primitives. Use these for every new page/section so the site stays consistent.
import styled from 'styled-components';

export const CONTAINER_MAX_WIDTH = '1320px';
export const SECTION_PADDING = 'clamp(64px, 9vw, 112px)';

export const Section = styled.section`
  padding: ${SECTION_PADDING} 0;
`;

export const Container = styled.div`
  max-width: ${CONTAINER_MAX_WIDTH};
  margin: 0 auto;
  padding: 0 15px;
`;

/** Centered section heading block: an <h2> (styled globally) plus optional <p> subtitle. */
export const SectionHeading = styled.div`
  text-align: center;
  margin-bottom: 38px;

  h2 {
    color: #0f1c2d;
    margin: 0 0 12px;
  }

  p {
    margin: 0;
    font-size: 16px;
    color: #1d2c40;
    line-height: 1.6;
  }
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: none;
  color: #f7fbff;
  background: #0f1c2d;
  padding: 14px 22px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 14px;
  transition: all 0.25s linear;
  border: 1px solid rgba(12, 28, 45, 0.25);
  box-shadow: 0 14px 30px rgba(12, 28, 45, 0.15);

  &:hover,
  &:focus,
  &:active {
    color: #f7fbff;
    transform: translateY(-2px);
    box-shadow: 0 18px 34px rgba(12, 28, 45, 0.25);
  }
`;

export const SecondaryButton = styled(Button)`
  background: rgba(255, 255, 255, 0.75);
  color: #0f1c2d;
  border: 1px solid rgba(12, 28, 45, 0.12);

  &:hover,
  &:focus,
  &:active {
    background-color: #ffffff;
    color: #0f1c2d;
  }
`;
